export default __webpack_public_path__ + "static/media/ecg_meta_modal.6868e24c.svg";